import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import { putAction, getAction } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { CustomSwitch, DateInput, IntInput, TextInput } from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import RTResults from "../ResultsTable/RTResults";

import { action as actionVar } from "variables/action";

export default function OtherCategory({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newResults, setNewResults] = useState({});
  const [totalsavingsmwh, setTotalsavingsmwh] = useState({});
  const [totalsavingsm3, setTotalsavingsm3] = useState({});
  const [totalsavingseuro, setTotalsavingseuro] = useState({});
  const [totalsavingsco2, setTotalsavingsco2] = useState({});
  const [totalproduction, setTotalproduction] = useState({});
  const [calculate, setCalculate] = useState(false);

  console.log(action);
  const handleInvestmentChange = (e) => {
    const { name, value } = e.target;
    
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        results: { ...prevState.parameters.results, [name]: value },
      },
    }));
    setCalculate(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        results: { ...prevState.parameters.results, [name]: value },
      },
    }));
  };
  const handleCeeeligibilityChange = (e) => {
    const ceeeligibilityValue = newResults?.[params]?.["ceeeligibility"] || false;
    // setNewResults((prevState) => ({
    //   ...prevState,
    //   [params]: {
    //     ...prevState.results,
    //     ceeeligibility: !ceeeligibilityValue,
    //   },
    // }));
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        results: {
          ...prevState.parameters.results,
          ceeeligibility: !ceeeligibilityValue,
        },
      },
    }));
  };

  useEffect(() => {
    setNewResults(action?.parameters || {});
  }, [action]);

  useEffect(() => {
    setCalculate(true);
  }, []);

  useEffect(() => {
    if (calculate) {
      calculatetotal();
      setCalculate(false);
    }
  }, [calculate]);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionResults(event);
  };
  const handleFinalizeSubmit = (event) => {
    createActionResults(event);
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        general: {
          ...prevState.parameters.general,
          status: "finished",
          realenddate: new Date().toISOString().slice(0, 10),
        },
      },
    }));
  };

  const createActionResults = async (event) => {
    axios
      .put(url, newResults, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        setAction((prevState) => ({
          ...prevState,
          parameters: newResults,
        }));
        if (res.status == 200) {
          setNotification("success", "Résultats modifiée");
          getActionData();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const getActionData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setAction(response.data || []);
        setNewResults(response.data.parameters || {});
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const calculatetotal = () => {
    var totalsavingsmwhtmp = 0;
    var totalsavingsm3tmp = 0;
    var totalsavingseurostmp = 0;
    var totalsavingsco2tmp = 0;
    var totalproductiontmp = 0;
    action.parameters.impact.targetedenergy.forEach((energy) => {
      //console.log(energy);
      if (energy.realsavings) {
        //console.log(energy.projectedfinalenergysavings);
        if (energy.id === 'water')
          totalsavingsm3tmp += Number(energy.realsavings);
        else
          totalsavingsmwhtmp += Number(energy.realsavings);
      }
      if (energy.savingseuro) {
        totalsavingseurostmp += Number(energy.savingseuro);
      }
      if (energy.savingsco2) {
        totalsavingsco2tmp += Number(energy.savingsco2);
      }
      if (energy.realproduction) {
        totalproductiontmp += Number(energy.realproduction);
      }
    });
    setTotalsavingsmwh(totalsavingsmwhtmp);
    setTotalsavingsm3(totalsavingsm3tmp);
    setTotalsavingseuro(totalsavingseurostmp);
    setTotalsavingsco2(totalsavingsco2tmp);
    setTotalproduction(totalproductiontmp);

    let results = { ...action.parameters?.results };
    let monthlysavings = totalsavingseurostmp / 12;
    let roi = (results.cost / monthlysavings).toFixed(2);
    results.realroi = roi;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        results: results,
      },
    }));
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateInput
            inputTitle={actionVar[params]["validationdate"]}
            dateInput={newResults?.[params]?.["validationdate"] || ""}
            handleDateInputChange={handleChange}
            name="validationdate"
            disabled={!actionplanupdate}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params]["validatedby"]}
            textInput={newResults?.[params]?.["validatedby"] || ""}
            handleTextInputChange={handleChange}
            name="validatedby"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      <GridContainer style={{ marginTop: "1rem" }}>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <div
            style={{
              border: "0.099rem solid rgba(0, 0, 0, .22)",
              borderRadius: "0.3rem",
              padding: "0 0.6rem",
              margin: "0rem 0.5rem 0rem",
            }}
          >
            <RTResults
              setCalculate={setCalculate}
            />
          </div>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newResults?.general?.category == "renewables" && (
            <IntInput
              inputTitle={actionVar[params]["totalproduction"]}
              intInput={totalproduction}
              name="totalproduction"
              disabled={true}
            />
          )}
          {newResults?.general?.category !== "contracts" && (
            <IntInput
              inputTitle={actionVar[params]["totalsavingsmwh"]}
              intInput={totalsavingsmwh}
              name="totalsavingsmwh"
              disabled={true}
            />
          )}
          {(newResults?.general?.category !== "contracts" || (newResults?.general?.category === "contracts" && newResults?.impact?.mode === "simple"))
            && (
              <IntInput
                inputTitle={actionVar[params]["totalsavingsco2"]}
                intInput={totalsavingsco2}
                name="totalsavingsco2"
                disabled={true}
              />
            )}
          <IntInput
            inputTitle={actionVar[params]["cost"]}
            intInput={newResults?.[params]?.["cost"] || ""}
            handleIntInputChange={handleInvestmentChange}
            name="cost"
            disabled={!actionplanupdate}
          />
          <IntInput
            inputTitle={actionVar[params]["realroi"]}
            intInput={newResults?.[params]?.["realroi"] || ""}
            handleIntInputChange={handleChange}
            name="realroi"
            disabled={true}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newResults?.general?.category !== "contracts" && (
            <IntInput
              inputTitle={actionVar[params]["totalsavingsm3"]}
              intInput={totalsavingsm3}
              name="totalsavingsm3"
              disabled={true}
            />
          )}
          <IntInput
            inputTitle={actionVar[params]["totalsavingseuro"]}
            intInput={totalsavingseuro}
            name="totalsavingseuro"
            disabled={true}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          {newResults?.general?.category !== "contracts" && (
            <CustomSwitch
              style={{ "margin": "1.3rem 0rem 0rem 1rem" }}
              inputTitle={actionVar[params]["ceeeligibility"]}
              checkedState={newResults?.[params]?.["ceeeligibility"] || false}
              handleSwitchChange={handleCeeeligibilityChange}
              name="ceeeligibility"
              disabled={!actionplanupdate}
            />)}
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newResults?.[params]?.["ceeeligibility"] === true && (
            <IntInput
              inputTitle={actionVar[params]["ceecumac"]}
              intInput={newResults?.[params]?.["ceecumac"] || ""}
              handleIntInputChange={handleChange}
              name="ceecumac"
              disabled={!actionplanupdate}
            />
          )}
        </GridItem>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          {newResults?.[params]?.["ceeeligibility"] === true && (
            <IntInput
              inputTitle={actionVar[params]["ceeeuros"]}
              intInput={newResults?.[params]?.["ceeeuros"] || ""}
              handleIntInputChange={handleChange}
              name="ceeeuros"
              disabled={!actionplanupdate}
            />
          )}
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextInput
            inputTitle={actionVar[params]["comments"]}
            textInput={newResults?.[params]?.["comments"] || ""}
            handleTextInputChange={handleChange}
            name="comments"
            multiline
            rows={4}
            disabled={!actionplanupdate}
          />
          <IntInput
            inputTitle={actionVar[params]["duration"]}
            intInput={newResults?.[params]?.["duration"] || ""}
            handleIntInputChange={handleChange}
            name="duration"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7} style={{
            marginTop: "15px",
            marginLeft: "8px",
          }}>
            <EditButton
              handleSubmit={handleSubmit}
              style={{
                marginTop: "15px",
                marginLeft: "8px",
              }}
            >
              Modifier
            </EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
